export const EVENT_DURATION_DEFAULT = {
  value: 60,
  label: "1 hour",
}

export const eventDurationOptions: [number, string][] = [
  [60, "1 hour"],
  [120, "2 hours"],
  [240, "4 hours"],
  [360, "6 hours"],
  [480, "8 hours"],
  [720, "12 hours"],
  [1440, "full day"],
  [2880, "2 days"],
]

export const TICKET_TYPES = {
  NO_ADVANCE_TICKETS: {
    value: "no_advance_tickets",
    label: "No Advance Tickets",
  },
  BN_TICKETS: {
    value: "bNTickets",
    label: "bandNada Tickets",
  },
  EXTERNAL_TICKETS: {
    value: "externalTickets",
    label: "External Tickets",
  },
}

export const ticketTypeOptions: [string, string][] = [
  [TICKET_TYPES.NO_ADVANCE_TICKETS.value, TICKET_TYPES.NO_ADVANCE_TICKETS.label],
  [TICKET_TYPES.BN_TICKETS.value, TICKET_TYPES.BN_TICKETS.label],
  [TICKET_TYPES.EXTERNAL_TICKETS.value, TICKET_TYPES.EXTERNAL_TICKETS.label],
]

export const PRICING_TYPES = {
  FREE: { value: "free", label: "Free" },
  SET_PRICE: { value: "set_price", label: "Set Price" },
  SLIDING_SCALE: { value: "sliding_scale", label: "Sliding Scale" },
}

export const pricingTypeOptions: [string, string][] = [
  [PRICING_TYPES.FREE.value, PRICING_TYPES.FREE.label],
  [PRICING_TYPES.SET_PRICE.value, PRICING_TYPES.SET_PRICE.label],
  [PRICING_TYPES.SLIDING_SCALE.value, PRICING_TYPES.SLIDING_SCALE.label],
]

export const pricingTypeOptionsFor = (ticketType: string): [string, string][] =>
  pricingTypeOptions

export const FEE_TYPES = {
  POST_PURCHASE: { value: "post_purchase", label: "I set the ticket price" },
  PRE_PURCHASE: { value: "pre_purchase", label: "I set what I want to receive" },
}

export const eventStatusOptions: [string, string][] = [
  ["published", "Public"],
  ["unpublished", "Unlisted"],
]

// Helper function to get the top of the next hour
export const getTopOfNextHour = (): Date => {
  const now = new Date()
  const nextHour = new Date(now)
  nextHour.setHours(now.getHours() + 1, 0, 0, 0)
  return nextHour
}

export const defaultConcertProps = {
  band_id: undefined,
  cover_image_url: undefined,
  description: "",
  duration_minutes: EVENT_DURATION_DEFAULT.value,
  end_dt: null,
  event_type: "inPersonEvent",
  id: undefined,
  location: { displayName: "" },
  max_rsvps: undefined,
  ticket_type: TICKET_TYPES.NO_ADVANCE_TICKETS.value,
  start_dt: getTopOfNextHour(),
  ticket_link_url: undefined,
  title: "",
  event_performances: [],
  post_collaborators: [],
}

// Helper function to safely convert start_dt to Date object
export const extractDateFromStartDt = (
  startDt: Date | string | null | undefined,
): Date => {
  if (!startDt) return new Date()

  if (startDt instanceof Date) {
    return startDt
  }

  if (typeof startDt === "string") {
    try {
      const date = new Date(startDt)
      if (!isNaN(date.getTime())) {
        return date
      }
    } catch (e) {
      // If parsing fails, return current date
    }
  }

  return new Date()
}
